import { Breadcrumb, Button, Col, Form, Input, Row, Select, Steps } from "antd";
import CWLayout from "../cwLayout";
import "./cwProfile.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { convertPersian, delay, fileToBase64, regexFormater, urltoFile, validateInput } from "../../../../tools/tools";
import DatePicker from "../../../auxiliary/datepicker/datepicker";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { useNavigate } from "react-router-dom";
import ReactInputMask from "react-input-mask";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import Loading from "../../../auxiliary/loader/loading";
import OTP from "../../../auxiliary/otp-modal/otp";
import { CheckTokenWithOTP, setTokenOTP } from "../../../../tools/services";
const CWProfile = () => {
	//================ Hook =========================
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmProfile] = Form.useForm();
	const { queryGender, queryActiveProvince, queryCityByCityId, queryActiveCityByProvinceId, queryActiveCountry, queryCertType } = useAPIPublic();
	const { queryCountSimCardByCertNo, queryProfileByCertNoVBirthDate, addressByPostcode } = useDealer();
	const refMsisdn = useRef();
	const [valMsisdn, setValMsisdn] = useState("");
	const formData = useSelector((state) => state?.from?.changeownership);
	const dispatch = useDispatch();
	const [isLangPersian, setIsLangPersian] = useState(true);
	const [isIran, setIsIran] = useState(true);

	//================ Hook =========================

	//================ State =========================

	const handleChangeCertType = (value) => {
		if (value === 1) {
			setIsLangPersian(false);
			frmProfile.setFieldValue("birthdate", "");
		} else {
			setIsLangPersian(true);
		}
		if (value !== 0) {
			setIsIran(false);
		} else {
			setIsIran(true);
		}
	};

	//#region Initial Data Set Form =================
	const [initialData, setInitialData] = useState({
		gender: [],
		counterSim: "-1",
		firstSimCard: false,
		country: [],
		certtype: [],
		province: [],
		city: [],
	});

	useEffect(() => {
		const callServInitial = async () => {
			//Call Service Gender
			if (initialData.gender.length === 0) {
				let resGender = await queryGender();
				if (resGender) {
					setInitialData((prev) => ({ ...prev, gender: resGender }));
				}
			}
			//cal service Country
			let resCountry = await queryActiveCountry();
			if (resCountry) {
				resCountry.sort((a, b) => {
					if (a.inT_OrderId < b.inT_OrderId) return -1;
					if (a.inT_OrderId > b.inT_OrderId) return 1;
					return 0;
				});
				setInitialData((prev) => ({ ...prev, country: resCountry }));
			}

			//cal certtype
			let resCertType = await queryCertType();
			if (resCertType) {
				setInitialData((prev) => ({ ...prev, certtype: resCertType }));
			}

			if (initialData.province.length === 0) {
				//Call Service Province
				let resProvince = await queryActiveProvince();
				if (resProvince) {
					setInitialData((prev) => ({ ...prev, province: resProvince }));
				}
			}
		};
		callServInitial();
	}, []);
	//#endregion Initial Data Set Form =================

	//#region Load Data Draft From Reducer ===========

	useEffect(() => {
		if (formData?.buyer?.profile) {
			handleCityListByProvinceId(formData?.buyer?.profile?.provinceid);
			frmProfile.setFieldsValue({
				certtype: formData?.buyer?.profile?.certtype,
				certno: formData?.buyer?.profile?.certno,
				birthdate: formData?.buyer?.profile?.birthdate,
				fname: formData?.buyer?.profile?.fname,
				lname: formData?.buyer?.profile?.lname,
				fathername: formData?.buyer?.profile?.fathername,
				gender: formData?.buyer?.profile?.gender,
				countryid: formData?.buyer?.profile?.countryid,
				identityno: formData?.buyer?.profile?.identityno,
				smsmobileno: formData?.buyer?.profile?.smsmobileno,
				typeforupload: formData?.buyer?.profile?.typeforupload,
				postalcode: formData?.buyer?.profile?.postalcode,
				provinceid: formData?.buyer?.profile?.provinceid,
				cityid: formData?.buyer?.profile?.cityid,
				tel: formData?.buyer?.profile?.tel,
				mainstreet: formData?.buyer?.profile?.mainstreet,
				alley: formData?.buyer?.profile?.alley,
				auxiliaryroad: formData?.buyer?.profile?.auxiliaryroad,
				buildingno: formData?.buyer?.profile?.buildingno,
				floor: formData?.buyer?.profile?.floor,
				unit: formData?.buyer?.profile?.unit,
			});
			setValMsisdn(formData?.buyer?.profile?.smsmobileno);
			handleChangeCertType(formData?.buyer?.profile?.certtype);
		}
	}, [formData]);
	//#endregion Load Data Draft From Reducer ===========

	//#region Check Counter Sim card Activated =======

	const handleCountSim = async (e) => {
		setServProfile((prev) => ({ ...prev, certNo: e.target.value }));
		if (e.target.value.length === 10 && e.target.value !== servProfile?.prevCertNo) {
			let payload = {
				certno: e.target.value,
			};
			let response = await queryCountSimCardByCertNo(payload);
			if (response != null) {
				setServProfile((prev) => ({ ...prev, prevCertNo: e.target.value }));
				if (response === 0) {
					setInitialData((prev) => ({
						...prev,
						firstSimCard: true,
						counterSim: response,
					}));
				} else {
					setInitialData((prev) => ({ ...prev, counterSim: response }));
				}
			}
		}
	};
	//#endregion Check Counter Sim card Activated =======

	//#region Call Service get all Cities From Province
	const handleCityListByProvinceId = async (item) => {
		let resCity = await queryActiveCityByProvinceId(item);
		if (resCity) {
			setInitialData((prev) => ({ ...prev, city: resCity }));
		}
	};
	//#endregion Call Service get all Cities From Province

	//#region callBack Function From Date picker ======
	const handleGetDate = (temp) => {
		frmProfile.setFieldValue("birthdate", temp);
		setServProfile((prev) => ({ ...prev, birtday: temp }));
	};
	//#endregion callBack Function From Date picker ======

	//#region Get Address From Service Post ===========
	//state postalCode ID
	const [postalCodeServ, setPostalCodeServ] = useState({
		postCode: "",
		prevCode: "",
	});
	//Call Service Read Postalcode From Service
	useEffect(() => {
		const CallPostalCode = async () => {
			if (postalCodeServ.postCode.length === 10 && postalCodeServ.postCode !== postalCodeServ.prevCode) {
				let payload = {
					postCode: frmProfile.getFieldValue("postalcode"),
				};
				let resPost = await addressByPostcode(payload);
				if (resPost) {
					setPostalCodeServ((prev) => ({
						...prev,
						prevCode: postalCodeServ.postCode,
					}));
					frmProfile.setFieldsValue({
						mainstreet: resPost?.mainStreet,
						buildingno: resPost?.buildingNo,
						floor: resPost?.floor,
						alley: resPost?.alley,
						auxiliaryroad: resPost?.auxiliaryRoad,
						tel: resPost?.tel,
					});
					if (resPost?.cityId) {
						let resProvince = await queryCityByCityId(resPost?.cityId);
						if (resProvince) {
							frmProfile.setFieldsValue({
								provinceid: resProvince?.provinceid,
							});
							handleCityListByProvinceId(resProvince?.provinceid);
						}
					}
				}
			}
		};
		CallPostalCode();
	}, [postalCodeServ.postCode]);
	//#endregion Get Address From Service Post ===========

	//#region Load Profile With Service ==============
	const [servProfile, setServProfile] = useState({
		birtday: "",
		prevBirtday: "",
		certNo: "",
		prevCertNo: "",
	});
	useEffect(() => {
		const handleReadProfile = async () => {
			if (servProfile.certNo.length === 10 && servProfile.birtday.length > 0) {
				if (servProfile.birtday !== servProfile.prevBirtday || servProfile.certNo !== servProfile.prevCertNo) {
					let payload = {
						certno: servProfile.certNo,
						birthdate: servProfile.birtday,
					};
					let response = await queryProfileByCertNoVBirthDate(payload);
					if (response) {
						setServProfile((prev) => ({
							...prev,
							prevBirtday: servProfile.birtday,
							prevCertNo: servProfile.certNo,
						}));
						frmProfile.setFieldsValue({
							fname: response?.fname,
							lname: response?.lname,
							fathername: response?.fathername,
							gender: response?.gender,
							identityno: response?.identityno,
							smsmobileno: response?.smsmobileno ? "0" + response?.smsmobileno.toString() : "",
						});
						setValMsisdn(response?.smsmobileno ? "0" + response?.smsmobileno.toString() : "");
						// document.getElementById("refMsisdn")?.value = response?.smsmobileno.toString().replace("9", "");
						if (response?.address?.postalcode?.length > 0) {
							frmProfile.setFieldValue("postalcode", response?.address?.postalcode);
							setPostalCodeServ((prev) => ({
								...prev,
								postCode: response?.address?.postalcode,
							}));
						}
					}
				}
			}
		};
		handleReadProfile();
	}, [servProfile.certNo, servProfile.birtday]);
	//#endregion Load Profile With Service ===========

	useEffect(() => {
		frmProfile.setFieldValue("smsmobileno", valMsisdn);
	}, [valMsisdn]);

	//Show Loader in Page
	const [isOpenOtp, setIsOpenOtp] = useState(false);
	//show Loader in Loading

	//#region submit Form Profile , Address and Document
	const handleSubmit = async (values) => {
		setIsOpenOtp(true);
	};
	//#endregion submit Form Profile , Address and Document

	//handle Get Token From OTP Service
	const handleGetToken = async (token) => {
		setIsOpenOtp(false);
		if (token) {
			// await setToken({
			//   token: token.token,
			//   expireUTCTime: token.expireUTCTime,
			// });
			// setAuthorization(token.token);

			await setTokenOTP({ expireUTCTime: token.expireUTCTime, token: token.token });
			const isTokenOTP = await CheckTokenWithOTP();
			if (isTokenOTP) {
				let txtGender = initialData?.gender.find((item) => item.value === frmProfile.getFieldValue("gender"))?.name;
				let txtProvince = initialData?.province.find((item) => item.inT__ProvinceId === frmProfile.getFieldValue("provinceid"))?.stR_ProvinceName;
				let txtCity = initialData?.city.find((item) => item.inT_CityId === frmProfile.getFieldValue("cityid"))?.stR_CityName;

				const profileValues = frmProfile.getFieldsValue();
				const photoBase64 = await fileToBase64(profileValues.photo);
				dispatch(
					simcardPurchase({
						changeownership: {
							...formData,
							buyer: {
								profile: {
									...profileValues,
									photo: photoBase64,
									txtGender: txtGender,
									txtProvince: txtProvince,
									txtCity: txtCity,
									isIran: isIran,
									isLangPersian: isLangPersian,
								},
							},
						},
					}),
				);
				nav(_adr.Root + _adr.ChangeOwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.Index + _adr.ChangeOwnerShip.OwnerShip.SwapDocument);
			}
		} else {
		}
	};
	//==========================================

	return (
		<CWLayout>
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("changeOwnerShip.ownership.title") }]}
					/>
					<div className="title-page">
						<h3>{t("changeOwnerShip.ownership.title")}</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className="g-body-format-page">
							<div className="g-format-steps">
								<div className="holder-step">
									<Steps
										size="small"
										className="step-wizard"
										current={1}
										responsive
										items={[
											{
												title: "اطلاعات فروشنده",
											},
											{
												title: "اطلاعات خریدار",
											},
											{
												title: "آپلود مدرک شناسایی",
											},
											{
												title: "پیش فاکتور",
											},
											{
												title: "سند",
											},
										]}
									/>
								</div>
							</div>
							<div className="cw-profile">
								<h3 className="header-of-form">اطلاعات هویتی </h3>
								<Form id="frmProfile" form={frmProfile} onFinish={handleSubmit} layout="vertical">
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item name="certtype" className="input-normal" rules={[validateInput({ t: t, validate: true })]} label="نوع مدرک شناسایی">
												<Select onChange={handleChangeCertType}>
													{initialData?.certtype.map((item, key) => (
														<Select.Option key={key} value={item.value}>
															{item.name}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}></Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="certno"
												label="شماره مدرک شناسایی"
												onBlur={handleCountSim}
												onChange={(e) => {
													e.target.value = convertPersian(e.target.value);
												}}
												rules={[validateInput({ t: t, validate: true })]}
												extra={
													<>
														{initialData.counterSim != -1 && (
															<>
																{10 - initialData.counterSim >= 0 ? (
																	<span className="result-sucess">
																		شما میتوانید <span>{10 - initialData.counterSim}</span> سیمکارت دیگر خریداری کنید{" "}
																	</span>
																) : (
																	<span className="result-unsucess">شما امکان خرید سیم کارت بیشتر از حد تعیین شده را ندارید</span>
																)}
															</>
														)}
													</>
												}>
												<Input dir="ltr" inputMode="numeric" maxLength={11} autoComplete="off" />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="birthdate" rules={[validateInput({ t: t, validate: true })]} label="تاریخ تولد">
												<DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} lang={isLangPersian} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="fname"
												label="نام"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: isLangPersian ? "persian" : "english",
													}),
												]}>
												<Input
													autoComplete="off"
													dir={isLangPersian ? "rtl" : "ltr"}
													onChange={(e) => (e.target.value = convertPersian(e.target.value))}
												/>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="lname"
												label="نام خانوادگی"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: isLangPersian ? "persian" : "english",
													}),
												]}>
												<Input
													autoComplete="off"
													dir={isLangPersian ? "rtl" : "ltr"}
													onChange={(e) => (e.target.value = convertPersian(e.target.value))}
												/>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="fathername"
												label="نام پدر"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: isLangPersian ? "persian" : "english",
													}),
												]}>
												<Input
													autoComplete="off"
													dir={isLangPersian ? "rtl" : "ltr"}
													onChange={(e) => (e.target.value = convertPersian(e.target.value))}
												/>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
												<Select>
													{initialData?.gender.map((item, key) => (
														<Select.Option key={key} value={item.value}>
															{item.name}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										{!isIran && (
											<Col xs={24} sm={12} md={12} lg={10} xl={8}>
												<Form.Item className="input-normal" name="countryid" label="کشور" rules={[validateInput({ t: t, validate: true })]}>
													<Select showSearch filterOption={(inputValue, option) => option.children.toString().startsWith(inputValue)}>
														{initialData?.country?.map((item, key) => (
															<Select.Option key={key} value={item.inT_CountryId}>
																{item.stR_CountryName}
															</Select.Option>
														))}
													</Select>
												</Form.Item>
											</Col>
										)}

										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="email"
												label="پست الکترونیکی"
												rules={[
													validateInput({
														t: t,
														validate: false,
														type: "email",
													}),
												]}>
												<Input dir="ltr" inputMode="email" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
									</Row>
									<h3 className="header-of-form">اطلاعات تماس </h3>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="smsmobileno"
												label={initialData?.firstSimCard ? "شماره معرف" : "شماره همراه"}
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "regexMsisdnFix",
													}),
												]}>
												<div>
													<ReactInputMask
														mask="0\999 99 99 999"
														id="refMsisdn"
														value={frmProfile.getFieldValue("smsmobileno")?.length > 0 ? frmProfile.getFieldValue("smsmobileno") : ""}
														// value={9991337053}
														onChange={(e) => {
															e.target.value = convertPersian(e.target.value);
															setValMsisdn(e.target.value);
														}}
														inputMode="numeric"
														className="msisdn-mask"
														dir="ltr"
													/>
												</div>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="tel"
												label="تلفن ثابت"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "number",
													}),
												]}>
												<Input
													placeholder="تلفن ثابت"
													inputMode="numeric"
													autoComplete="off"
													dir="ltr"
													onChange={(e) => (e.target.value = convertPersian(e.target.value))}
												/>
											</Form.Item>
										</Col>
									</Row>
									<h3>اطلاعات آدرس </h3>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="postalcode"
												label="کدپستی"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "number",
														length: 10,
													}),
												]}>
												<Input
													onBlur={(e) => {
														setPostalCodeServ((prev) => ({
															...prev,
															postCode: e.target.value,
														}));
													}}
													onChange={(e) => (e.target.value = convertPersian(e.target.value))}
													dir="ltr"
													maxLength={10}
													inputMode="numeric"
													placeholder="کدپستی خود را وارد کنید"
												/>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="provinceid" label="استان" rules={[validateInput({ t: t, validate: true })]}>
												<Select
													filterOption={(inputValue, option) => {
														return option.children.toString().includes(inputValue.toString());
													}}
													onChange={(item, option) => {
														handleCityListByProvinceId(item);
													}}
													showSearch>
													{initialData.province.map((item) => (
														<Select.Option key={item.inT__ProvinceId} value={item.inT__ProvinceId}>
															{item.stR_ProvinceName}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="cityid" label="شهر" rules={[validateInput({ t: t, validate: true })]}>
												<Select
													filterOption={(inputValue, option) => {
														return option.children.toString().includes(inputValue.toString());
													}}
													showSearch>
													{initialData?.city.map((item, key) => (
														<Select.Option key={key} value={item.inT_CityId}>
															{item.stR_CityName}
														</Select.Option>
													))}
												</Select>
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="mainstreet"
												label="خیابان اصلی"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "persian",
													}),
												]}>
												<Input placeholder="خیابان اصلی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="auxiliaryroad"
												label="خیابان فرعی"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "persian",
													}),
												]}>
												<Input placeholder="خیابان فرعی" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="alley"
												label="کوچه"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "persian",
													}),
												]}>
												<Input placeholder="کوچه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item
												className="input-normal"
												name="buildingno"
												label="پلاک"
												rules={[
													validateInput({
														t: t,
														validate: true,
														type: "number",
													}),
												]}>
												<Input placeholder="پلاک" inputMode="numeric" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="floor" label="طبقه" rules={[validateInput({ t: t, validate: true })]}>
												<Input placeholder="طبقه" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={30}>
										<Col xs={24} sm={12} md={12} lg={10} xl={8}>
											<Form.Item className="input-normal" name="unit" label="واحد" rules={[validateInput({ t: t, validate: true })]}>
												<Input autoComplete="off" placeholder="واحد" onChange={(e) => (e.target.value = convertPersian(e.target.value))} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
							</div>
						</div>
						<div className="g-footer-format-page">
							<div className="holder-button">
								<Button
									disabled={10 - initialData.counterSim > 0 ? false : true}
									form="frmProfile"
									key="submit"
									htmlType="submit"
									className="btn-normal btn-aptel">
									ادامه
								</Button>
								<Button
									onClick={() =>
										nav(
											_adr.Root +
												_adr.ChangeOwnerShip.Index +
												_adr.ChangeOwnerShip.OwnerShip.Index +
												_adr.ChangeOwnerShip.OwnerShip.InformationSeller,
										)
									}
									className="btn-normal">
									بازگشت
								</Button>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<OTP
				isOpen={isOpenOtp}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_CW}
				callback={handleGetToken}
				certno={frmProfile.getFieldValue("certno")}
				expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
				msisdn={valMsisdn?.length > 0 ? regexFormater(valMsisdn?.slice(1) || " ").removeSpace() : ""}
				sessionid={Date.now()}
			/>
		</CWLayout>
	);
};

export default CWProfile;
